import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TMockupSubmissionState, TSubmission } from './types';
import { TBaseResponse } from '../../../commonTypes/basic';

export const initialState: TMockupSubmissionState = {
  data: [],
  totalCount: 0,
  totalFailedCount: 0,
  totalSuccessCount: 0,
  errorMessage: '',
  isLoading: false
};

const reducerSlice = createSlice({
  name: 'MockupSubmission',
  initialState,
  reducers: {
    setData: (state, { payload }: PayloadAction<TBaseResponse<TSubmission>>): void => {
      state.data = payload.data.items;
      state.totalCount = payload.totalCount;
      state.errorMessage = payload.data.submissionStatus === 3 ? payload.data.message : '';
      state.totalFailedCount = payload.data.totalFailedCount;
      state.totalSuccessCount = payload.data.totalSuccessCount;
      state.isLoading = false;
    },

    setIsLoading: (state, { payload }: PayloadAction<boolean>): void => {
      state.isLoading = payload;
    },

    resetData: () => initialState
  }
});

export const { setData, setIsLoading, resetData } = reducerSlice.actions;

export default reducerSlice.reducer;
